import {
  ACCEPT_HOST_REQUEST,
  CLOSE_REASON_DIALOGUE,
  GET_HOST_REQUEST,
  GET_HOST_REQUEST_LOADING,
  OPEN_REASON_DIALOGUE,
} from "./types";

const initialState = {
  request: [],
  isLoading: false,
  dialog: false,
  dialogData: null,
};

const hostRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HOST_REQUEST_LOADING:
      return {
        ...state,
        isLoading: true,
        request: [],
      };

    case GET_HOST_REQUEST:
      return {
        ...state,
        isLoading: false,
        request: action.payload,
      };

    case ACCEPT_HOST_REQUEST:
      return {
        ...state,
        request: state.request.filter(
          (request) => request._id !== action?.payload
        ),
      };
    case OPEN_REASON_DIALOGUE:
      return {
        ...state,
        dialog: true,
        dialogData: action.payload || null,
      };
    case CLOSE_REASON_DIALOGUE:
      return {
        ...state,
        dialog: false,
        dialogData: null,
      };

    default:
      return state;
  }
};

export default hostRequestReducer;
